module.exports = __webpack_public_path__ + "static/no-prize.6ec1a652.svg";